export type PlaceholderValue =
  | string
  | number
  | boolean
  | null
  | undefined
  | Date;

export function interpolateTranslation(
  template: string,
  values: Record<string, PlaceholderValue> = {},
): string {
  // Preserve escaped left braces so they don't get matched by the regex
  const ESCAPE_SENTINEL = '___ESC_LBRACE___';

  const withEscaped = template.replace(/\\{{/g, ESCAPE_SENTINEL);

  const result = withEscaped.replace(
    /{{\s*([a-zA-Z0-9_.-]+)\s*}}/g,
    (_match, key: string) => {
      const rawValue = values[key];

      if (rawValue === undefined || rawValue === null) {
        return '';
      }

      // Stringify (Date -> ISO) and make safe for replace() backrefs
      const stringValue =
        rawValue instanceof Date ? rawValue.toISOString() : String(rawValue);

      return stringValue.replace(/\$/g, '$$$$');
    },
  );

  // Restore escaped sequences
  return result.replace(new RegExp(ESCAPE_SENTINEL, 'g'), '{{');
}
